// Curated Unsplash images used as fallbacks across the site.
// All URLs include sensible sizing params for fast loading.

const u = (id: string, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=70`;

export const HERO_IMAGES = {
  donate: u("1532629345422-7515f3d16bb6", 1800),       // hands giving
  events: u("1511795409834-ef04bbd61622", 1800),       // people gathered
  gallery: u("1521295121783-8a321d551ad2", 1800),      // elder smiling
  committee: u("1573497019940-1c28c88b4f3e", 1800),    // committee meeting
  trustees: u("1556761175-5973dc0f32e7", 1800),        // boardroom
  contact: u("1423666639041-f56000c27a9a", 1800),      // letters/contact
  news: u("1504711434969-e33886168f5c", 1800),         // newspaper
  feedback: u("1556761175-b413da4baf72", 1800),        // feedback / conversation
  jainPanchang: u("1545551318847-380463c239d7", 1800), // temple / spiritual
  tiffin: u("1567337710282-00832b415979", 1800),       // indian thali
  inkind: u("1488521787991-ed7bbaae773c", 1800),       // donation boxes
  scrap: u("1558618664-fcd25c85cd64", 1800),           // furniture / appliances
  about: u("1517021897933-0e0319cfbc28", 1800),        // caregiver and elder
  residentCare: u("1559757175-5700dde675bc", 1800),    // elderly care
};

export const FALLBACK_GALLERY = [
  u("1521295121783-8a321d551ad2", 900),
  u("1518152006812-edab29b069ac", 900),
  u("1559131397-f94da358f7ca", 900),
  u("1547425260-76bcadfb4f2c", 900),
  u("1488521787991-ed7bbaae773c", 900),
  u("1506784983877-45594efa4cbe", 900),
  u("1469571486292-0ba58a3f068b", 900),
  u("1517021897933-0e0319cfbc28", 900),
  u("1532629345422-7515f3d16bb6", 900),
  u("1511795409834-ef04bbd61622", 900),
  u("1559757175-5700dde675bc", 900),
  u("1542810634-71277d95dcbb", 900),
];

export const FALLBACK_NEWS = [
  u("1504711434969-e33886168f5c", 1000),
  u("1495020689067-958852a7765e", 1000),
  u("1432821596592-e2c18b78144f", 1000),
  u("1585829365295-ab7cd400c167", 1000),
];

export const FALLBACK_EVENT_BANNER = [
  u("1511795409834-ef04bbd61622", 1200),
  u("1540575467063-178a50c2df87", 1200),
  u("1492684223066-81342ee5ff30", 1200),
  u("1523580494863-6f3031224c94", 1200),
];

export function pickFrom<T>(arr: T[], seed: string | number, idx = 0): T {
  const s = String(seed) + idx;
  let h = 0;
  for (let i = 0; i < s.length; i++) {h = (h * 31 + s.charCodeAt(i)) >>> 0;}
  return arr[h % arr.length];
}
